import formatErrors from '../../../functions/formatErrors';
import { LoginState } from '../objects/loginState';
import {
    LoginActionTypes,
    SET_ERRORS,
    SET_MFA_ATTEMPTS_REMAINING,
    SET_MFA_CODE_ERROR,
    SET_MFA_PENDING,
    TOGGLE_FORGOT_PASSWORD,
    TOGGLE_FORGOT_PASSWORD_EMAIL_SENT,
    TOGGLE_PASSWORD,
    UPDATE_EMAIL,
    UPDATE_MFA_CODE,
    UPDATE_PASSWORD
} from './actionTypes';

const MFA_MAX_ATTEMPTS = 3;

const initialState: LoginState = {
    email: '',
    email_error: '',
    forgot_password: false,
    forgot_password_email_sent: false,
    mfa_attempts_remaining: MFA_MAX_ATTEMPTS,
    mfa_code: '',
    mfa_code_error: '',
    mfa_pending: false,
    mfa_sent_at: null,
    password: '',
    password_error: '',
    show_password: false
};

export default (state = initialState, action: LoginActionTypes): LoginState => {
    switch (action.type) {
        case UPDATE_EMAIL: {
            return {...state, email: action.payload};
        }
        case UPDATE_PASSWORD: {
            return {...state, password: action.payload};
        }
        case UPDATE_MFA_CODE: {
            return {...state, mfa_code: action.payload, mfa_code_error: ''};
        }
        case SET_MFA_PENDING: {
            // Reset MFA state entier à chaque nouveau cycle send/
            return {
                ...state,
                mfa_pending: action.payload,
                mfa_code: '',
                mfa_code_error: '',
                mfa_attempts_remaining: MFA_MAX_ATTEMPTS,
                mfa_sent_at: action.payload ? Date.now() : null
            };
        }
        case SET_MFA_ATTEMPTS_REMAINING: {
            return {...state, mfa_attempts_remaining: action.payload};
        }
        case SET_MFA_CODE_ERROR: {
            return {...state, mfa_code_error: action.payload};
        }
        case TOGGLE_FORGOT_PASSWORD: {
            return {...state, forgot_password: !state.forgot_password, forgot_password_email_sent: false};
        }
        case TOGGLE_FORGOT_PASSWORD_EMAIL_SENT: {
            return {...state, forgot_password_email_sent: true};
        }
        case TOGGLE_PASSWORD: {
            return {...state, show_password: !state.show_password};
        }
        case SET_ERRORS: {
            const { email, password } = action.payload;
            return {
                ...state,
                email_error: email ? Array.isArray(email) ? formatErrors(email) : email : '',
                password_error: password ? Array.isArray(password) ? formatErrors(password) : password : ''
            };
        }
        default:
            return state;
    }
};